var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.123 12.668V15.668H22.123V17.668H19.123V20.668H17.123V17.668H14.123V15.668H17.123V12.668H19.123ZM19.1312 0.667969C19.679 0.667969 20.123 1.11292 20.123 1.66137V10.668H18.123V2.66797H2.12305V16.667L12.123 6.66797L15.123 9.66797V12.497L12.123 9.49637L4.95005 16.668H12.123V18.668H1.11485C0.567097 18.668 0.123047 18.2231 0.123047 17.6746V1.66137C0.123047 1.11273 0.578357 0.667969 1.11485 0.667969H19.1312ZM6.12305 4.66797C7.22762 4.66797 8.12305 5.5634 8.12305 6.66797C8.12305 7.77257 7.22762 8.66797 6.12305 8.66797C5.01848 8.66797 4.12305 7.77257 4.12305 6.66797C4.12305 5.5634 5.01848 4.66797 6.12305 4.66797Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.282931b6a23b62f62c59f007807287cb.svg";
export { ForwardRef as ReactComponent };